import {observer} from "mobx-react-lite";
import {Link, useParams} from "react-router-dom";
import {SubscriptionCallbackStatus} from "../../../entity/enums/subscription-callback-status";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import {Box, Button, Card, CardContent, Divider, Typography} from "@mui/material";
import React, {useState} from "react";
import {useService} from "../../../infrastructure/service/service";
import LoadingComponent from "../components/widget/LoadingComponent";

import '../../../assets/css/style.css';
import '../../../assets/css/pages/subscription-callback.css';

const SubscriptionCallback = (): JSX.Element => {
    const {userService} = useService();
    const {status} = useParams();

    const [isLoggingOut, setLoggingOut] = useState<boolean>(false);

    const handleLogOut = async (): Promise<void> => {
        if (status === SubscriptionCallbackStatus.EXPIRED) {
            setLoggingOut(true);
            await userService.logout();
            setLoggingOut(false);
        }
    }

    return (
        <>
            <Box className={'body-box subscription-callback-container'}>
                <Card elevation={0} className={'chart-card subscription-callback-card'}>
                    <CardContent className={'subscription-callback-container description'}>
                        {
                            status === SubscriptionCallbackStatus.SUCCESS || status === SubscriptionCallbackStatus.PAYMENT_SUCCESS
                                ? <Box className={'subscription-callback-icon-container success'}>
                                    <CheckCircleRoundedIcon className={'subscription-callback-icon success'}/>
                                  </Box>
                                : <Box className={'subscription-callback-icon-container warning'}>
                                    <DisabledByDefaultRoundedIcon className={'subscription-callback-icon warning'}/>
                                  </Box>
                        }
                        <Typography id={'text-subscription-status'} className={'subscription-callback-header'}>
                            {
                                status === SubscriptionCallbackStatus.EXPIRED
                                    ? 'Subscription Expired'
                                    : status === SubscriptionCallbackStatus.SUCCESS
                                        ? 'Payment Successful'
                                        : status === SubscriptionCallbackStatus.CANCEL
                                            ? 'Payment Failed'
                                            : status === SubscriptionCallbackStatus.PAYMENT_SUCCESS
                                                ? 'Payment Method Updated'
                                                : 'Payment Method Update Failed'
                            }
                        </Typography>
                        <Typography id={'text-subscription-description'} className={'subscription-callback-description'}>
                            {
                                status === SubscriptionCallbackStatus.EXPIRED
                                    ? 'Your subscription has not been activated.'
                                    : status === SubscriptionCallbackStatus.SUCCESS
                                        ? 'Your payment has been processed, and your Zitles Plan is now active.'
                                        : status === SubscriptionCallbackStatus.CANCEL
                                            ? 'Payment was not processed. Your subscription has not been activated.'
                                            : status === SubscriptionCallbackStatus.PAYMENT_SUCCESS
                                                ? 'Your payment method has been successfully updated.'
                                                : 'Payment method update was unsuccessful. Please check your details and try again.'
                            }
                        </Typography>
                        <Typography id={'text-subscription-footer'} className={'subscription-callback-footer'}>
                            {
                                status === SubscriptionCallbackStatus.EXPIRED
                                    ? 'Please contact your organization administrator for access to the Zitles platform.'
                                    : status === SubscriptionCallbackStatus.SUCCESS
                                        ? 'Thank you for subscribing! You can now access all features.'
                                        : status === SubscriptionCallbackStatus.CANCEL
                                            ? 'Check your payment details and try again. If the issue persists, contact support for assistance.'
                                            : status === SubscriptionCallbackStatus.PAYMENT_SUCCESS
                                                ? 'Future payments will be processed using the new details.'
                                                : 'If the issue persists, contact support for assistance.'
                            }
                        </Typography>
                        <Divider className={'subscription-callback-divider'} />
                        <Button
                            id={'btn-subscription-callback'}
                            className={'zitles-button submit'}
                            component={Link}
                            onClick={handleLogOut}
                            to={status === SubscriptionCallbackStatus.SUCCESS || status === SubscriptionCallbackStatus.PAYMENT_SUCCESS ? '/dashboard' : '/subscription'}>
                            {
                                status === SubscriptionCallbackStatus.EXPIRED
                                    ? 'Log Out'
                                    : status === SubscriptionCallbackStatus.SUCCESS || status === SubscriptionCallbackStatus.PAYMENT_SUCCESS
                                        ? 'Go to Dashboard'
                                        : 'Try Again'
                            }
                        </Button>
                    </CardContent>
                </Card>
            </Box>
            {
                isLoggingOut &&
                    <LoadingComponent title={'Logging Out...'}/>
            }
        </>
    );
}

export default observer(SubscriptionCallback);
